
import { AuthModule } from '@/store/modules/AuthModule'
import { NotifyModule } from '@/store/modules/NotifyModule'
import { ToastModule } from '@/store/modules/ToastModule'
import EmployeeService from '@/views/employee/services/employee-service'
import ParticipantService from '../../../../../services/participant.service'
import RepositoryService from '../../../../../services/repository-service'
import EmployeeModal from '@/views/employee/components/EmployeeModal.vue'
import {
  Component,
  Vue
} from 'vue-property-decorator'
import Draggable from 'vuedraggable'

@Component({
  name: 'Participant',
  components: {
    Draggable,
    EmployeeModal
  }
})
export default class Participant extends Vue {
  protected isTableBusy = false
  protected isDrag = false
  protected isEmployeesUpdated: any = false
  protected participants: any = []
  protected employees: any = []
  protected companies: any = []
  protected company: any = {}

  created () {
    this.boot()
  }

  public boot () {
    this.populateEmployees()
    this.populateCompanyNames()
    this.addLine()
  }

  protected showMasterData () {
    (this.$refs.EmployeeModal as any).open()
  }

  protected editParticipant (participant) {
    (this.$refs.EmployeeModal as any).populateEmployee(participant.employee_id)
    this.showMasterData()
  }

  public async setParticipant (tableIndex: number, participant: any) {
    console.log('participant', participant)
    if (Object.keys(this.company).length === 0) {
      NotifyModule.set('Please select a company first.. ')
      this.participants[tableIndex].member = {}
      this.participants[tableIndex].nic_number = null
      this.participants[tableIndex].category = null
      this.participants[tableIndex].designation = null
      return false
    }

    const exists = this.participants.some((p, i) => i !== tableIndex && p.employee_id === participant.employee_id)
    if (exists) {
      NotifyModule.set('Member already added. Please select another.. ')
      this.participants[tableIndex].member = {}
      this.participants[tableIndex].nic_number = null
      this.participants[tableIndex].category = null
      this.participants[tableIndex].designation = null
      return false
    }

    this.participants[tableIndex].employee_id = participant.employee_id
    this.participants[tableIndex].employee_name = participant.employee_name
    this.participants[tableIndex].nic_number = participant.nic_number
    this.participants[tableIndex].category = participant.category
    this.participants[tableIndex].designation = participant.designation
  }

  protected deleteParticipant (tableIndex: number, participant: any) {
    if (participant.id === null) {
      this.participants.splice(tableIndex, 1)
    } else {
      if (confirm(`Are you sure you want to delete this Participant ${participant.employee_name}?`) === true) {
        ParticipantService.deleteParticipant(participant.id).then((response) => {
          ToastModule.message(response.data.message)
          this.participants.splice(tableIndex, 1)
        }).catch(error => {
          ToastModule.message(error.response.data.message)
        })
      }
    }
  }

  protected save () {
    const list: any = []
    this.participants.forEach((participant, index) => {
      list.push({
        id: participant.id,
        line_number: index + 1,
        company_id: participant.company_id ?? this.company.id,
        employee_id: participant.employee_id,
        created_user: participant.created_user ?? AuthModule.user.fullname,
        modified_user: AuthModule.user.fullname
      })
    })
    ParticipantService.saveParticipants(list).then((response) => {
      ToastModule.message(response.data.message)
      this.populateParticipants()
      this.isEmployeesUpdated = false
    }).catch(error => {
      ToastModule.message(error.response.data.message)
    })
  }

  protected addLine () {
    this.participants.push({
      id: null,
      member: {},
      employee_id: null,
      employee_name: null,
      nic_number: null,
      category: null,
      designation: null,
      created_user: AuthModule.user.fullname,
      modified_user: AuthModule.user.fullname
    })
  }

  protected async populateParticipants () {
    this.isTableBusy = true
    this.participants = []
    const response = await ParticipantService.getParticipants(this.company.id)
    if (response.data.length === 0 && this.participants.length === 0) {
      this.addLine()
    } else {
      this.participants = response.data.map(participant => {
        // ...participant,
        /* member: {
          employee_id: participant.employee_id,
          employee_name: participant.employee_name,
          nic_number: participant.nic_number,
          category: participant.category,
          designation: participant.designation
        } */
        const match = this.employees.find(employee => employee.value.employee_id === participant.employee_id)
        return {
          ...participant,
          member: match || {}
        }
      })
    }
    this.isTableBusy = false
    this.isEmployeesUpdated = false
  }

  private async populateCompanyNames () {
    const response = await RepositoryService.getCompanies()
    response.data.forEach((element) => {
      this.companies.push({
        value: {
          id: element.id,
          name: element.name
        },
        text: element.name
      })
    })
  }

  protected async populateEmployees () {
    this.employees = []
    this.participants = []
    const response = await EmployeeService.getAllEmployees()
    response.data.forEach((element) => {
      this.employees.push({
        value: {
          employee_id: element.id,
          employee_name: element.name,
          nic_number: element.nic_number,
          category: element.category,
          designation: element.designation
        },
        text: element.name
      })
    })

    if (this.isEmployeesUpdated && Object.keys(this.company).length !== 0) this.populateParticipants()
  }
}
